import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPokemons() {
      return new Promise((resolve, reject) => {
        axios
          .get('https://pokeapi.co/api/v2/')
          .then(response => {
            // eslint-disable-next-line
            console.log(response)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
